<script setup lang="ts">
// -------------------------------
// 🔹 Imports Vue et composables
// -------------------------------
import { toRaw, watchEffect } from 'vue';
import { useQuery } from '@tanstack/vue-query';

// -------------------------------
// 🔹 Imports composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';
import BaseCheckBox from '../common/BaseCheckBox.vue';
import BaseIncAndDecreMentBtn from '../common/BaseIncAndDecreMentBtn.vue';

// -------------------------------
// 🔹 Imports stores Pinia
// -------------------------------
import { useProductStore } from '@/store/product.store';

// -------------------------------
// 🔹 Imports utilitaires
// -------------------------------

// -------------------------------
// 🔹 Imports assets / refs / données
// -------------------------------
import {
  errorMessage,
  file,
  form_product_step_one,
  previewUrl,
  arraysStepOne,
  category_product,
  stepOneActive,
  stepTwoActive,
  descriptionPageProduct,
  arraysStepTwo,
  stepThreeActive,
  dynamicExtraOptions,
  NumberOfTotalField,
  isUpdatedProduct,
  selected,
} from '@/refs/product.refs';
import { IconUploadCloud } from '@/assets/svg/common.svg';
import { useCategoryStore } from '@/store/category.store';
import AddMultipleOption from './AddMultipleOption.vue';
import { replaceAmp } from '@/utils/replaceAmp';

// -------------------------------
// 🔹 Imports Types
// -------------------------------

// -------------------------------
// 🔹 Props et emits instanciés
// -------------------------------

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------
const productStore = useProductStore();
const categoryStore = useCategoryStore();

// -------------------------------
// 🔹 Récupération des commandes avec Vue Query
// -------------------------------
const {
  data: dataGetProduct,
  isLoading: isLoadingGetProduct,
  isError: isErrorGetProduct,
  refetch: refectGetProduct,
} = useQuery({
  queryKey: ['GetProduct'],
  queryFn: () => productStore.getProduct(),
});

// -------------------------------
// 🔹 Toutes les refs,les props et les declarations des variable
// -------------------------------

// -------------------------------
// 🔹 Toutes les fonctions
// -------------------------------

const HandleCheckedDesignation = (
  e: Event,
  indexValue: number,
  secondIndex: number,
) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'firstField' + indexValue;
  const index = arraysStepTwo.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepTwo.value.splice(index, 1);
      //   console.log(${title}' supprimé du tableau (champ vide).`);
    } else {
    }
  } else {
    const newItem = { value: secondIndex, title };
    if (index !== -1) {
      arraysStepTwo.value[index] = newItem;
    } else {
      arraysStepTwo.value.push(newItem);
    }
  }

  // console.log("Tableau actuel :", toRaw(arraysStepTwo.value));
};
const HandleCheckedTitleOPtion = (
  e: Event,
  indexValue: number,
  secondIndex: number,
) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'optionsField' + indexValue;
  const index = arraysStepTwo.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepTwo.value.splice(index, 1);
    } else {
    }
  } else {
    const newItem = { value: secondIndex, title };
    if (index !== -1) {
      arraysStepTwo.value[index] = newItem;
    } else {
      arraysStepTwo.value.push(newItem);
    }
  }

  // console.log("Tableau actuel :", toRaw(arraysStepTwo.value));
};

const HandleCheckedTitlePrice = (
  e: Event,
  indexValue: number,
  secondIndex: number,
) => {
  console.log('indexValue :', indexValue);
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'price' + indexValue;
  const index = arraysStepTwo.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepTwo.value.splice(index, 1);
    } else {
    }
  } else {
    const newItem = { value: secondIndex, title };
    if (index !== -1) {
      arraysStepTwo.value[index] = newItem;
    } else {
      arraysStepTwo.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepTwo.value));
};
const HandleCheckedTypeQty = (e: Event, indexValue: number) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'secondField' + indexValue;
  const index = arraysStepTwo.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepTwo.value.splice(index, 1);
    } else {
      console.log('Le champ est vide (aucune entrée à supprimer).');
    }
  } else {
    const newItem = { value: indexValue - 1, title };
    if (index !== -1) {
      arraysStepTwo.value[index] = newItem;
    } else {
      arraysStepTwo.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepTwo.value));
};

const HandleCheckedValueQty = (e: Event, indexValue: number) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'thirdField' + indexValue;
  const index = arraysStepTwo.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepTwo.value.splice(index, 1);
    } else {
      console.log('Le champ est vide (aucune entrée à supprimer).');
    }
  } else {
    const newItem = { value: indexValue - 1, title };
    if (index !== -1) {
      arraysStepTwo.value[index] = newItem;
    } else {
      arraysStepTwo.value.push(newItem);
    }
  }

  // console.log("Tableau actuel :", toRaw(arraysStepTwo.value));
};

const HandleCheckedCondition = (e: Event, indexValue: number) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'forthField' + indexValue;
  const index = arraysStepTwo.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepTwo.value.splice(index, 1);
    } else {
      console.log('Le champ est vide (aucune entrée à supprimer).');
    }
  } else {
    const newItem = { value: indexValue, title };
    if (index !== -1) {
      arraysStepTwo.value[index] = newItem;
    } else {
      arraysStepTwo.value.push(newItem);
    }
  }
};

const goToNextPage = () => {
  if (isUpdatedProduct.value) {
    stepOneActive.value = true;
    stepTwoActive.value = false;
    stepThreeActive.value = false;
  } else {
    descriptionPageProduct.value =
      'Produit / Nouveau produit / Informations du produit / Ajouter des accompagnements/Personaliser le taxe et restaurant';
    stepOneActive.value = false;
    stepTwoActive.value = false;
    stepThreeActive.value = true;
  }
};

const HandleInscrement = () => {
  dynamicExtraOptions.value.push({
    designation: '',
    price: '',
    taxe: '',
    image: '',
    categorie: '',
    description: '',
    nameExtra: '',
    typeQty: '',
    valueQty: '',
    conditionExtra: '',
    extraOptions: [
      {
        name: '',
        price: '',
      },
    ],
  });
};

const HandleDecreInscrement = (index?: number) => {
  if (dynamicExtraOptions.value.length <= 1 || index === undefined) return;
  dynamicExtraOptions.value.splice(index, 1);
  arraysStepTwo.value = arraysStepTwo.value
    .filter((item) => item?.value !== index)
    .map((item) => ({ ...toRaw(item) }));
};

const HandleInscrementOptions = (extraIndex: number) => {
  dynamicExtraOptions.value[extraIndex].extraOptions.push({
    name: '',
    price: '',
  });
};

const HandleDecreInscrementOptions = (
  extraIndex: number,
  optionIndex: number,
  index: number,
) => {
  const titleOptions = 'optionsField' + (index + 2);
  const titleprice = 'price' + (index + 3);
  console.log(titleOptions);
  console.log(titleprice);
  const options = dynamicExtraOptions.value[extraIndex].extraOptions;
  if (options.length <= 1) return;
  options.splice(optionIndex, 1);
  arraysStepTwo.value = arraysStepTwo.value
    .filter(
      (item) => item?.title !== titleOptions && item?.title !== titleprice,
    )
    .map((item) => ({ ...toRaw(item) }));

  // console.log(toRaw(arraysStepTwo.value));
};

const handleSubmit = () => {
  if (isUpdatedProduct.value) {
    stepOneActive.value = false;
    stepTwoActive.value = false;
    stepThreeActive.value = true;
  } else {
    goToNextPage();
  }
};

// -------------------------------
// 🔹 Debugging (optionnel)
// -------------------------------
watchEffect(() => {
  let totalOptions = 0;
  dynamicExtraOptions.value.forEach((item) => {
    totalOptions += item.extraOptions.length;
  });

  const totalExtraField =
    dynamicExtraOptions.value.length * 4 + totalOptions * 2;
  NumberOfTotalField.value = totalExtraField;
  console.log('LOngeure du tableua :', NumberOfTotalField.value);
});
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-6"
  >
    <div id="form_container">
      <div
        class="space-y-[16px]"
        v-for="(item, index) in dynamicExtraOptions"
        :key="index"
      >
        <div class="flex flex-row items-center justify-between">
          <h1 class="text-grand-text font-tt-medium-Normal text-20px leading-6">
            Souhaitez-vous ajouter {{ replaceAmp(String(index + 1)) }} extras ?
          </h1>

          <BaseIncAndDecreMentBtn
            @HandleDecreInscrement="() => HandleDecreInscrement(index)"
            :sateIncrement="index + 1"
            @HandleInscrement="() => HandleInscrement()"
          />
        </div>
        <div class="space-y-4">
          <div class="flex w-full flex-row gap-4">
            <div class="flex-1 space-y-8">
              <TextInput
                @HandleTextInput="
                  (e: Event, index, secondIndex) =>
                    HandleCheckedDesignation(e, index, secondIndex)
                "
                v-model="item.nameExtra"
                name="Nom  de l'extra"
                placeholder="Nom  de l'extra"
                type="text"
                id="Nom  de l'extra"
                label="Nom  de l'extra"
                :index="index + 1"
                :secondIndex="index"
              />
              <div
                class="flex w-full flex-row items-center justify-between gap-4"
              >
                <div class="flex flex-col gap-2">
                  <label
                    for="taxe"
                    class="text-14px font-tt-medium-Normal leading-normal"
                  >
                    Veuillez sélectionner le type de quantité
                    <!-- <span class="text-decroissance text-14px leading-normal">*</span> -->
                  </label>

                  <select
                    id="taxe"
                    name="taxe"
                    v-model="item.typeQty"
                    @change="(e) => HandleCheckedTypeQty(e, index + 1)"
                    class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
                  >
                    <option value="">Choisissez une option</option>
                    <option value="max">Quantité maximale</option>
                    <option value="min">Quantité minimale</option>
                    <option value="exact">Quantité exacte</option>
                  </select>
                </div>

                <TextInput
                  @HandleTextInput="
                    (e: Event) => HandleCheckedValueQty(e, index + 1)
                  "
                  class="flex-1"
                  v-model="item.valueQty"
                  name="Entrez le nombre exact de la quantité"
                  placeholder="Entrez le nombre exact de la quantité"
                  type="text"
                  id="Entrez le nombre exact de la quantité"
                  label="Entrez le nombre exact de la quantité"
                />
              </div>

              <div class="flex flex-col gap-2">
                <label
                  for="taxe"
                  class="text-14px font-tt-medium-Normal leading-normal"
                >
                  Veuillez sélectionner une condition
                </label>

                <select
                  id="taxe"
                  name="Taxe sur produit"
                  v-model="item.conditionExtra"
                  @change="(e: Event) => HandleCheckedCondition(e, index)"
                  class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
                >
                  <option value="">Choisissez une option</option>
                  <option value="unique">Choix unique</option>
                  <option value="multiple">Choix multiples</option>
                </select>
              </div>
            </div>
          </div>

          <div class="space-y-6">
            <h1
              class="text-grand-text font-tt-medium-Normal text-20px leading-6"
            >
              Ajouter autant d’option que vous souhaitez associé à cet extra
            </h1>

            <div
              class="flex w-full flex-row items-center gap-4"
              v-for="(_sateIncrement, optIndex) in item?.extraOptions"
              :key="optIndex"
            >
              <div class="flex w-full flex-row items-center gap-2">
                <TextInput
                  @HandleTextInput="
                    (e: Event, optIndex, secondIndex) =>
                      HandleCheckedTitleOPtion(
                        e,
                        optIndex + 1 + index + 1,
                        index,
                      )
                  "
                  v-model="_sateIncrement.name"
                  name="Nom  de l'extra"
                  placeholder="Nom  de l'extra"
                  type="text"
                  id="Titre de l'option"
                  :label="`Titre de l'option ${optIndex + 1}`"
                  :index="optIndex + 1 + index + 1"
                  :secondIndex="index"
                  class="flex-1"
                />
                <TextInput
                  @HandleTextInput="
                    (e: Event, optIndex, secondIndex) =>
                      HandleCheckedTitlePrice(
                        e,
                        optIndex + 2 + (index + 1),
                        secondIndex,
                      )
                  "
                  v-model="_sateIncrement.price"
                  name="prix  de l'extra"
                  placeholder="prix  de l'extra"
                  type="text"
                  id="prix de l'option"
                  :label="`prix de l'option ${optIndex + 1}`"
                  :index="optIndex + 1 + index + 1"
                  :secondIndex="index"
                  class="flex-1"
                />
              </div>
              <BaseIncAndDecreMentBtn
                @HandleDecreInscrement="
                  () =>
                    HandleDecreInscrementOptions(
                      index,
                      optIndex,
                      optIndex + 1 + index + 1,
                    )
                "
                :sateIncrement="optIndex + 1"
                @HandleInscrement="() => HandleInscrementOptions(index)"
              />
            </div>
          </div>

          <div>
            <div class="my-4 flex flex-row items-center gap-2">
              <input type="checkbox" v-model="item.required" />
              <label
                for="extradValue"
                class="text-12px font-tt-normal-Normal text-decroissance leading-normal"
              >
                {{ 'Veuillez dire si cet Extra sera obligatoire ?' }}
              </label>
            </div>
          </div>
        </div>
        <div class="invisible h-[50px] w-full bg-red-600" />
      </div>
    </div>

    <div class="flex flex-row items-end justify-end gap-4">
      <div @click="goToNextPage">
        <BaseButtonPrimary
          type="button"
          :label="isUpdatedProduct ? 'Page précédente' : 'Oublier cette étape'"
          style_of_btn="secondary_color_of_btn "
          class="text-grand-text"
        />
      </div>
      <BaseButtonPrimary
        type="submit"
        label="Sauvegarder et continuer"
        style_of_btn="primary_color_of_btn "
        class="text-white"
      />
    </div>
  </form>
</template>
